import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import styles from './ExpensesNavigator.module.css'

const ExpensesNavigator = () => {
    const location = useLocation()

    const isActive = (path, { startsWith = false } = {}) => (
        startsWith ? location.pathname.startsWith(path) : location.pathname === path
    )

    return (
        <>
            <div className={styles.headerWrapper}>
                <div className={styles.allTitles}>
                    <Link to="/expenses/summary" className={isActive('/expenses/summary') ? styles.eachActiveTitle : styles.eachTitle}>
                        Summary
                    </Link>
                    <Link to="/expenses/history" className={isActive('/expenses/history', { startsWith: true }) ? styles.eachActiveTitle : styles.eachTitle}>
                        All Expenses
                    </Link>
                    <Link to="/expenses/add" className={isActive('/expenses/add') ? styles.eachActiveTitle : styles.eachTitle}>
                        Add New
                    </Link>
                    <Link to="/expenses/review" className={isActive('/expenses/review', { startsWith: true }) ? styles.eachActiveTitle : styles.eachTitle}>
                        Review
                    </Link>
                    <Link to="/settings/expenses" className={isActive('/settings/expenses') ? styles.eachActiveTitle : styles.eachTitle}>
                        Settings
                    </Link>
                </div>
            </div>
            <div className={styles.headerSpacer} />
        </>
    )
}

export default ExpensesNavigator